import React, { useEffect, useState } from 'react'
import { FiPlus, FiMinus } from "react-icons/fi";
import { IoArrowBackCircle, IoArrowForwardCircle } from "react-icons/io5";
import { motion } from 'framer-motion'
import { ThreeDots }from 'react-loader-spinner';
import { faqs } from '../../data/faqData';




const Faq1 = ({setFaq}) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [faqsToRender, setFaqsToRender] = useState([]);


    useEffect(() => {
      const fetchData = async () => {
        try {
          // This is to demonstrate the loading state
          await new Promise((resolve) => setTimeout(resolve, 1500));
          setFaqsToRender(faqs.slice(0, 12));
        } finally {
          setLoading(false);
        }
      };
      fetchData();
      
    }, []);
    
    const handleFaq = (item) => {
      setOpen((prevIndex) => prevIndex === item ? null : item )
    }

    
  return (
    <div className='flex flex-col items-center w-full px-5 md:px-6 lg:px-7 xl:px-10'>
                {/*ACCORDION*/}
                <div
                 className='flex flex-col items-center w-full mt-5 md:mt-7 lg:mt-8'>
                {
                  loading ? (
                    <div className='flex items-start justify-center w-full h-screen mt-24'>
                        <ThreeDots
                         color="#25A249"
                        />
                    </div>
                  ) : (
            
                  faqsToRender.map((item) => {
                  return(
                <motion.div
                     initial={{scale: 1, opacity: 0 }}
                     animate={{scale: 1, opacity: [0, 0.1, 0.3, 0.5, 1.0], y:['100%', '0%'] }}
                     transition={{ duration: 0.5, delay: item.id * 0.2, easing: "easeOut", }}
                     key={item.id} 
                     className={`flex flex-col items-start w-full bg-[#F9FAFB] rounded-md border-[1px] cursor-pointer border-[#DDE1E6] px-4 py-3 mb-3 md:py-4 md:px-5 md:mb-4 md:rounded-lg lg:mb-[18px] xl:rounded-xl
                                 xl:py-5 xl:mb-[22px] xl:px-7 ${open && 'py-4 md:py-5'}`}>
                     <div onClick={()=>handleFaq(item.id)}
                     className='flex items-start justify-between w-full'>
                        <p className='text-[10px] font-semibold text-[#101828] w-[85%] md:text-xs xl:text-base'>
                            {item.question}
                        </p>
                        {
                          open === item.id
                          ?<FiMinus className='text-[#101828] text-base lg:text-lg xl:text-[22px]' />
                          :<FiPlus className='text-[#101828] text-base lg:text-lg xl:text-[22px]' />
                        }
                     </div>
  
                     {open === item.id &&
                       <p className='text-[10px] font-normal text-[#5c5453] w-[91%] leading-5 pt-3 md:text-xs md:leading-[22px] md:pt-4 md:w-[95%] lg:text-[12.5px] xl:text-base 
                                     xl:leading-7 xl:pt-5'>
                                     {item.answer}
                       </p>
                     }
                </motion.div>
                  )
                }))
              }
  
           </div>
  
  
           {/*BOTTOM BUTTON*/}
           
           <div className='flex items-center justify-end w-full mt-7 lg:mt-9 xl:mt-12'>
                <div className='flex items-center justify-center w-[95px] text-[#858585] bg-[#ffffff] border-[2px] border-[#858585] rounded-md py-1.5 cursor-pointer md:w-[105px] md:rounded-lg 
                                xl:w-[125px] xl:py-2 xl:border-[3px]'>
                   <IoArrowBackCircle className='text-base md:text-lg xl:text-xl' />
                   <p className='text-[10px] font-normal pl-1.5 md:text-[11px] xl:text-sm'>
                       Previous
                   </p>
                </div>
  
                <div onClick={()=>setFaq(2)}
                className='flex items-center justify-center w-[95px] text-[#ffffff] bg-[#25A249] border-[2px] border-[#25A249] rounded-md py-1.5 ml-3.5 cursor-pointer md:w-[105px] 
                                md:ml-5 md:rounded-lg xl:w-[125px] xl:py-2 xl:ml-6 xl:border-[3px]'>
                    <p className='text-[10px] font-normal pr-1.5 md:text-[11px] xl:text-sm xl:pr-2.5'>
                       Next
                    </p>
                    <IoArrowForwardCircle className='text-base md:text-lg xl:text-xl' />
                </div>
           </div>
           
    </div>
  )
}

export default Faq1
